import { Center, Stack, Text, Title } from '@mantine/core';

export interface IEmptyStateProps {
  header?: string;
  description?: string;
}

/** @registry Centered placeholder (title + description) for empty lists/tables; default description "No data found". */
export const EmptyState: React.FC<IEmptyStateProps> = ({
  header,
  description = 'No data found',
}) => {
  return (
    <Center p="xl">
      <Stack>
        <Title c="dimmed" order={5}>
          {header}
        </Title>
        <Text>{description}</Text>
      </Stack>
    </Center>
  );
};
